import { expand, EMPTY, reduce, Observable, of, skip } from 'rxjs';
import { IClientApiDependencySegment, IApiSymbol } from '@cbridge-packages/api';
import { fetchBaseSymbols, IBaseSymbolsQueryParams } from './fetchBaseSymbols';

type IDependencies = IClientApiDependencySegment;

export const fetchBaseSymbolsRecursively = (
  initialQueryParams: IBaseSymbolsQueryParams,
  dependencies: IDependencies,
): Observable<IApiSymbol[]> => {
  return of(initialQueryParams).pipe(
    expand(({ limit, skip, search, isLastPage }) => {
      return isLastPage
        ? EMPTY
        : fetchBaseSymbols({ limit, skip, search }, dependencies);
    }),
    skip(1),
    reduce((symbols, { symbols: nextSymbols }) => {
      return symbols.concat(nextSymbols);
    }, [] as IApiSymbol[]),
  );
};
